
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic13Static as ObiHydraulic13StaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-13-static.js';
 
 
 

 
 export const ObiHydraulic13Static = createComponent({
   react: React,
   tagName: 'obi-hydraulic-13-static',
   elementClass: ObiHydraulic13StaticElement,
   events: {
     
   }
  });
 
 